exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@400;500;700&display=swap);", ""]);

// module
exports.push([module.id, ".v-pagination__item,.v-pagination__item--active,.v-pagination__navigation{box-shadow:0 1px 1px -1px rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 1px 2px 0 rgba(0,0,0,.12)}.ProseMirror:focus{outline:none}.tt-indent-1{padding-left:40px}.tt-indent-2{padding-left:80px}.tt-indent-3{padding-left:120px}.tt-indent-4{padding-left:160px}.tt-indent-5{padding-left:200px}.tt-indent-6{padding-left:240px}.tt-indent-7{padding-left:280px}.tt-indent-8{padding-left:320px}", ""]);

// exports
